import { isEmpty } from 'lodash';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

import { RemoveIcon } from '@assets/icons';

const selectedFilterConfig = [
    {
        key: 'scheme',
        label: 'Promo Scheme',
        getDisplayValue: (val) => `${val?.length} Terpilih`,
    },
    {
        key: 'status',
        label: 'Status',
        getDisplayValue: (val) => `${val?.length} Terpilih`,
    },
    {
        key: 'dateStart',
        label: 'Start Date',
        getDisplayValue: (val) => val,
    },
    {
        key: 'dateEnd',
        label: 'End Date',
        getDisplayValue: (val) => val,
    },
];

export default function SelectedFilterList({ filtersState, onRemoveFilterItem, onResetFilter }) {
    return (
        <Flex alignItems={'center'} gap={'16px'}>
            <Text fontWeight={700} fontSize={'xs'}>
                Filters by:
            </Text>

            {selectedFilterConfig.map(({ key, label, getDisplayValue }) => {
                const value = filtersState?.[key];
                const isActive = Array.isArray(value) ? value.length > 0 : !isEmpty(value);

                if (!isActive) return null;

                return (
                    <Flex
                        key={key}
                        p={'8px'}
                        gap={'8px'}
                        bg={'semantic.200'}
                        borderRadius={'2px'}
                        alignItems={'center'}
                    >
                        <Text fontWeight={700} fontSize={'xs'}>
                            {label}:{' '}
                            <Box display={'inline'} fontWeight={'400'}>
                                {getDisplayValue(value)}
                            </Box>
                        </Text>
                        <Box onClick={() => onRemoveFilterItem(key)} cursor={'pointer'}>
                            <RemoveIcon />
                        </Box>
                    </Flex>
                );
            })}

            <Button variant={'outline'} onClick={onResetFilter} size={'sm'}>
                Reset All
            </Button>
        </Flex>
    );
}
